import type { ReactNode } from 'react';
import type { ThemeTokens } from '@/shared/ui/theme/tokens';
import { BackButton } from '@/presentation/components/BackButton';

// ── Types ─────────────────────────────────────────────────────────────────────

interface EnrollmentScreenLayoutProps {
  onBack: () => void;
  title: string;
  badgeLabel: string;
  badgeColor: string; // hex or CSS color
  T: ThemeTokens;
  children: ReactNode;
}

// ── Component ─────────────────────────────────────────────────────────────────

export function EnrollmentScreenLayout({
  onBack,
  title,
  badgeLabel,
  badgeColor,
  T,
  children,
}: EnrollmentScreenLayoutProps) {
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        background: T.bg,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Centered wrapper container (Item 3 requirement: maxWidth 645px) */}
      <div
        data-testid="enrollment-wrapper"
        style={{
          maxWidth: '645px',
          margin: '0 auto',
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: '18px 30px',
            borderBottom: `1px solid ${T.border}`,
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            flexShrink: 0,
          }}
        >
          <BackButton T={T} onClick={onBack} />
          <div
            style={{
              flex: 1,
              textAlign: 'center',
              fontSize: 14,
              fontWeight: 700,
              color: T.clockText,
            }}
          >
            {title}
          </div>
          <div
            style={{
              padding: '5px 12px',
              borderRadius: 15,
              fontSize: 9,
              fontWeight: 700,
              letterSpacing: '.06em',
              background: `${badgeColor}18`,
              color: badgeColor,
            }}
          >
            {badgeLabel}
          </div>
        </div>

        {/* Body */}
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: '32px 30px 28px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
